import { render, staticRenderFns } from "./formPopup.vue?vue&type=template&id=58bca2ca&"
import script from "./formPopup.vue?vue&type=script&lang=js&"
export * from "./formPopup.vue?vue&type=script&lang=js&"
import style0 from "./formPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports